import { useQuery } from 'react-query'
import { ENTITY_TYPES } from '@sales-center/common'
import { ServiceConfig } from '@user/store/services/config'
import { ISalesFunnelClosedReasons } from '@user/store/salesFunnel/typings'
import { get } from '@user/store/services/crud'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.salesFunnel.salesFunnel}`

const getReasonsByFunnelId = async (id: string, entityType: ENTITY_TYPES) => {
  if (id !== '') {
    const path =
      entityType === ENTITY_TYPES.Lead
        ? 'leadClosedReasons'
        : 'oppClosedReasons'

    const response = await get(`${baseUrl}/${path}/${id}`)
    if (response.ok) return (await response.json()) as ISalesFunnelClosedReasons
  }

  return {
    id: -1,
    tenantId: '',
    name: '',
    isDefault: false,
    allowManualDisqualifyReasons: false,
    disqualifyReasons: [],
  }
}

export const useGetClosedReasons = (
  salesFunnelId: string,
  entityType: ENTITY_TYPES,
) =>
  useQuery(
    ['bulkActions', 'updateStatus', 'closedReasons', entityType, salesFunnelId],
    () => getReasonsByFunnelId(salesFunnelId, entityType),
  )
